import styled from 'styled-components';

var SlideRating = styled.div.withConfig({
  displayName: "style__SlideRating",
  componentId: "sc-2vbv4q-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;margin:0 0 10px;&:last-child{margin:0;}"]);
var Label = styled.span.withConfig({
  displayName: "style__Label",
  componentId: "sc-2vbv4q-1"
})(["color:var(--color-grey-800);margin:0 0 3px;width:100%;"]);
var Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-2vbv4q-2"
})(["display:flex;flex-direction:row;width:100%;"]);
var Bar = styled.span.withConfig({
  displayName: "style__Bar",
  componentId: "sc-2vbv4q-3"
})(["align-self:center;background-color:var(--color-grey-100);display:block;height:6px;margin:0 15px 0 0;width:100%;"]);
var Progress = styled.span.withConfig({
  displayName: "style__Progress",
  componentId: "sc-2vbv4q-4"
})(["animation-duration:1s;animation-name:animateBar;background-color:var(--color-teal-800);display:block;height:6px;"]);
var Rating = styled.span.withConfig({
  displayName: "style__Rating",
  componentId: "sc-2vbv4q-5"
})(["flex-grow:0;font-family:var(--font-family-thomas-headline);font-size:17px;text-align:center;width:24px;"]);

export { Bar, Container, Label, Progress, Rating, SlideRating };
//# sourceMappingURL=style.js.map
